import { c as _c } from "react/compiler-runtime";
import { Image } from '@/app/components/media/image';
import { MEDIA_QUERY_DEVICE_SIZE, MEDIA_QUERY_SOURCE, MEDIA_QUERY_SOURCE_IMAGE_WIDTH } from '@/app/components/media/image/constants';
import type { StepFormPropsWithVariant } from '@/app/lcv/components/campaigns/big-campaign-2026/types';
interface KvBannerProps {
  imageCover: StepFormPropsWithVariant['imageCover'];
}
export const KvBanner = t0 => {
  const $ = _c(36);
  const {
    imageCover
  } = t0;
  const mobileSrc = imageCover?.mobile ?? "";
  const tabletSrc = imageCover?.tablet ? imageCover.tablet : imageCover?.mobile || "";
  let t1;
  if ($[0] !== imageCover?.tablet) {
    t1 = imageCover?.tablet ? ["aspect-1-1", "md:aspect-16-9"] : "aspect-16-9";
    $[0] = imageCover?.tablet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      minWidth: MEDIA_QUERY_DEVICE_SIZE.tablet_lg
    };
    t3 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.tablet_lg
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== tabletSrc) {
    t4 = {
      srcset: tabletSrc,
      media: t2,
      options: t3
    };
    $[4] = tabletSrc;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.tablet_md
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== tabletSrc) {
    t6 = {
      srcset: tabletSrc,
      media: MEDIA_QUERY_SOURCE.tablet_md,
      options: t5
    };
    $[7] = tabletSrc;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.tablet_sm
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== mobileSrc) {
    t8 = {
      srcset: mobileSrc,
      media: MEDIA_QUERY_SOURCE.tablet_sm,
      options: t7
    };
    $[10] = mobileSrc;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.mobile_lg
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== mobileSrc) {
    t10 = {
      srcset: mobileSrc,
      media: MEDIA_QUERY_SOURCE.mobile_lg,
      options: t9
    };
    $[13] = mobileSrc;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.mobile_md
    };
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== mobileSrc) {
    t12 = {
      srcset: mobileSrc,
      media: MEDIA_QUERY_SOURCE.mobile_md,
      options: t11
    };
    $[16] = mobileSrc;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.mobile_sm
    };
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== mobileSrc) {
    t14 = {
      srcset: mobileSrc,
      media: MEDIA_QUERY_SOURCE.mobile_sm,
      options: t13
    };
    $[19] = mobileSrc;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      width: MEDIA_QUERY_SOURCE_IMAGE_WIDTH.mobile_xs
    };
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== mobileSrc) {
    t16 = {
      srcset: mobileSrc,
      media: MEDIA_QUERY_SOURCE.mobile_xs,
      options: t15
    };
    $[22] = mobileSrc;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t14 || $[27] !== t16 || $[28] !== t4 || $[29] !== t6 || $[30] !== t8) {
    t17 = [t4, t6, t8, t10, t12, t14, t16];
    $[24] = t10;
    $[25] = t12;
    $[26] = t14;
    $[27] = t16;
    $[28] = t4;
    $[29] = t6;
    $[30] = t8;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== mobileSrc || $[33] !== t1 || $[34] !== t17) {
    t18 = <Image priority={true} src={mobileSrc} width={320} height={180} alt={"my-MEMBER my-Bonus \u0E04\u0E27\u0E32\u0E21\u0E2A\u0E38\u0E02\u0E2A\u0E48\u0E07\u0E15\u0E48\u0E2D\u0E44\u0E14\u0E49 - \u0E2D\u0E35\u0E0B\u0E39\u0E0B\u0E38\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22 Isuzu Thailand Official"} aspectRatio={t1} className="xl:hidden" sources={t17} />;
    $[32] = mobileSrc;
    $[33] = t1;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
};